import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Building2 } from 'lucide-react';

function CompanyHeader() {
    return (
        <Box
            sx={{
                bgcolor: 'background.paper',
                borderBottom: '1px solid',
                borderColor: 'divider',
                py: 2
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        maxWidth: '1024px', // max-w-5xl equivalent
                        mx: 'auto'
                    }}
                >
                    {/* Icon Box */}
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2, // rounded-lg
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}
                    >
                        <Building2 size={20} color="white" />
                    </Box>
                    
                    {/* Heading */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontSize: '1.5rem', // text-2xl
                            fontWeight: 600, // font-semibold
                            letterSpacing: '-0.025em', // tracking-tight
                            m: 0
                        }}
                    >
                        My Company
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export default CompanyHeader;
